import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { DataService } from 'src/app/services/data.service';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { finalize, takeUntil } from 'rxjs/operators';
import { IceapiService } from '../../../../../services';
import { LubricantModel } from '../../../models';
import { Router } from '@angular/router';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { JointCalcService } from 'src/app/Modules/idms/components/plant-manager/services/joint-calc-service.service';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-lubricant',
    templateUrl: './lubricant.component.html',
    styleUrls: ['./lubricant.component.scss'],
})
export class LubricantComponent implements OnInit, OnDestroy {
    @Input() form: UntypedFormGroup;
    @Input() enable: boolean;
    destroy$ = new Subject();

    tooltip_position = 'above';
    loading: boolean = false;
    lubricantList: LubricantModel[];
    lubricantTypeList = new Map([
        ['0', 'µ'],
        ['1', 'k'],
    ]);
    calculationType: number;

    constructor(
        private iceapi: IceapiService,
        private dataService: DataService,
        private globalEmittersService: GlobalEmittersService,
        private route: Router,
        private user_utility: UserUtilityService,
        private dataSvc: DataService,
        private jointcalcService: JointCalcService
    ) {}

    ngOnInit(): void {
        if (!this.jointcalcService.isPipeCode) {
            this.getLubricants();
        } else if (this.jointcalcService.isPipeCode) {
            this.pipespecwithLubricant();
        }

        this.form.markAllAsTouched();
        if (this.form != null) {
            this.form
                .get('lubricant')
                .valueChanges.pipe(takeUntil(this.destroy$))
                .subscribe((value) => {
                    if (value) {
                        this.setLubricantTypeAndValue(value);
                        if (this.route.url == '/idms/plantmanager' || this.route.url.includes('/idms/plantmanagerView')) {
                            this.jointcalcService.selectedLubricant.next(value);
                        }
                    }
                });

            this.form
                .get('lubricantType')
                .valueChanges.pipe(takeUntil(this.destroy$))
                .subscribe((value) => {
                    this.disableLubricantValue(value);
                    this.dataSvc.selectedToolId = null;
                    this.dataSvc.selectedToolName = null;
                    this.globalEmittersService.isCalculationHappen.next(false);
                });
        }

        // * getting calculation type
        this.globalEmittersService.currentCalculationType.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.calculationType = res;
        });

        // * changing unit of lubricant based on tightening specification
        this.globalEmittersService.lubricantUnitTighteningSpecification.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            if (res.isEvent && this.calculationType != -1 && this.calculationType != 2) {
                this.handleLubricantUnit(res.dropdownValue);
            }
        });
    }

    setLubricantTypeAndValue(value: string): void {
        const selectv = this.lubricantList.find((o) => o.lubricantId == value);
        if (selectv?.coefficient) {
            this.form.get('lubricantValue').setValue(this.lubricantList.find((o) => o.lubricantId == value)?.coefficient);
        } else if (this.lubricantList.length > 0 && this.lubricantList[0]?.coefficient) {
            this.form.get('lubricantValue').setValue(this.lubricantList[0]?.coefficient);
        }

        if (selectv?.lubricantName) {
            this.dataService.selectedLubricantObject = this.lubricantList.find((o) => o.lubricantId == value)?.lubricantName;
        } else if (this.lubricantList.length > 0 && this.lubricantList[0]?.lubricantName) {
            this.dataService.selectedLubricantObject = this.lubricantList[0]?.lubricantName;
        }

        //Change due to bug no : 5298
        // this.form.get("lubricantType").setValue('0');

        if (selectv?.kfactor) {
            this.form
                .get('lubricantType')
                .valueChanges.pipe(takeUntil(this.destroy$))
                .subscribe((value1) => {
                    if (value1 == 1) {
                        this.form.get('lubricantValue').setValue(this.lubricantList.find((o) => o.lubricantId == value)?.kfactor);
                    }
                });
        } else if (this.lubricantList.length > 0 && this.lubricantList[0]?.kfactor) {
            this.form.get('lubricantValue').setValue(this.lubricantList[0]?.kfactor);
        }

        if (!selectv?.lubricantName) {
            this.form.get('lubricant').setValue(this.lubricantList[0]?.lubricantId);
        }
    }

    disableLubricantValue(value: string): void {
        if (value == '0') {
            this.form.get('lubricantValue').setValue(this.lubricantList.find((o) => o.lubricantId == this.form.get('lubricant').value)?.coefficient);
            this.form.get('lubricantValue').clearValidators();
            // this.form.get('lubricantValue').disable();
        } else {
            this.form.get('lubricantValue').reset();
            this.form.get('lubricantValue').enable();
            this.form.get('lubricantValue').setValidators([Validators.required, Validators.min(0.01), Validators.max(0.99)]);
        }
        this.form.get('lubricantValue').updateValueAndValidity();
    }

    getLubricants(): void {
        this.loading = true;
        this.form.markAllAsTouched();
        this.iceapi
            .getLubricants()
            .pipe(
                finalize(() => {
                    this.loading = false;
                })
            )
            .pipe(takeUntil(this.destroy$))
            .subscribe((lubricantModels) => {
                if (lubricantModels.success === true) {
                    this.lubricantList = lubricantModels.response;
                    if (this.lubricantList.length == 1) {
                        this.form.get('lubricant').setValue(this.lubricantList[0].lubricantId);
                        this.setLubricantTypeAndValue(this.form.get('lubricant').value);
                    }
                    if (this.form.get('lubricant').value !== '') this.setLubricantValue(this.form.get('lubricant').value);
                    this.dataService.lubricantList = lubricantModels.response;
                } else {
                    this.user_utility.errorModelPopup(lubricantModels.message);
                }
            });
    }

    setLubricantValue(lubricantId: string) {
        if (this.form.get('lubricantType').value !== '' && this.form.get('lubricantType').value == '0') {
            this.setLubricantTypeAndValue(lubricantId);
        }
    }

    // * handle lubricant unit selection
    handleLubricantUnit(tighteningSpecification: string) {
        switch (tighteningSpecification) {
            case 'TorqueLongForm':
                this.form.get('lubricantType').setValue('0');
                break;

            case 'TorqueShortForm':
                this.form.get('lubricantType').setValue('1');
                break;
        }
    }

    async pipespecwithLubricant() {
        this.loading = true;
        let Lubricantlist = await this.iceapi
            .getLubricants()
            .pipe(finalize(() => (this.loading = false)))
            .toPromise();
        if (Lubricantlist.success) {
            this.lubricantList = Lubricantlist.response;

            let list = await this.jointcalcService.FinddingPipeSpecApicall(this.jointcalcService.pipeSpecpayload);

            let standardpipeSpec = [...new Set(list.map((x) => x.recordId.lubricantId))];

            if (standardpipeSpec?.length) {
                this.lubricantList = this.lubricantList.filter((item) => standardpipeSpec.includes(item.lubricantId));

                if (this.dataService.calculationData?.input?.recordId?.lubricantId) {
                    this.form.get('lubricant').setValue(this.dataService.calculationData?.input?.recordId?.lubricantId);
                    this.setLubricantTypeAndValue(this.form.get('lubricant').value);
                } else if (this.lubricantList.length == 1) {
                    this.form.get('lubricant').setValue(this.lubricantList[0].lubricantId);
                    this.setLubricantTypeAndValue(this.form.get('lubricant').value);
                }
            }
        } else if (Lubricantlist.isCustom) {
            this.user_utility.errorModelPopup(Lubricantlist.message);
        }

        // }
        // });
    }

    disableArrowKeys(event: KeyboardEvent): void {
        if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
            event.preventDefault();
        }
    }

    disableScroll(event: WheelEvent): void {
        event.preventDefault();
    }

    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
